<p-dialog
  [header]="'selecthorAdmin.customerList.invoiceDialog.header' | transloco"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '650px'}"
  [closable]="true"
  data-testid="invoice-data-dialog"
>
  <ng-container *transloco="let t; prefix: 'selecthorAdmin.customerList.invoiceDialog'">
    @if (invoiceData(); as data) {
      <div class="space-y-5">
        <div class="space-y-3">
          <h4 class="text-lg font-semibold">{{ t('companyInfo') }}</h4>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <span class="text-sm font-medium block">{{
                'common.legalCompanyName' | transloco
              }}</span>
              <p class="mt-1">{{ data.legalCompanyName }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{ 'common.legalForm' | transloco }}</span>
              <p class="mt-1">{{ data.legalForm }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{ 'common.vatNumber' | transloco }}</span>
              <p class="mt-1">{{ data.vatNumber }}</p>
            </div>
          </div>
        </div>

        <div class="space-y-3">
          <h4 class="text-lg font-semibold">{{ t('addressInfo') }}</h4>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <span class="text-sm font-medium block">{{ 'common.street' | transloco }}</span>
              <p class="mt-1">{{ data.street }} {{ data.number }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{ 'common.city' | transloco }}</span>
              <p class="mt-1">{{ data.zipCode }} {{ data.city }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{ 'common.country' | transloco }}</span>
              <p class="mt-1">{{ data.country }}</p>
            </div>
            @if (data.additionalInformation) {
              <div>
                <span class="text-sm font-medium block">{{
                  'common.additionalInformation' | transloco
                }}</span>
                <p class="mt-1">{{ data.additionalInformation }}</p>
              </div>
            }
          </div>
        </div>

        <div class="space-y-3">
          <h4 class="text-lg font-semibold">{{ t('billingInfo') }}</h4>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <span class="text-sm font-medium block">{{ 'common.invoiceEmail' | transloco }}</span>
              <p class="mt-1">{{ data.invoiceEmail }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{
                'common.responsibleForInvoices' | transloco
              }}</span>
              <p class="mt-1">{{ data.responsibleForInvoicesEmail }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{ 'common.costCenter' | transloco }}</span>
              <p class="mt-1">{{ data.costCenter }}</p>
            </div>
            <div>
              <span class="text-sm font-medium block">{{
                'common.internalInformation' | transloco
              }}</span>
              <p class="mt-1">{{ data.internalInformation }}</p>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <p>{{ t('noData') }}</p>
    }
  </ng-container>

  <ng-template #footer>
    <p-button
      [label]="'common.close' | transloco"
      (onClick)="close()"
      severity="secondary"
      data-testid="close-invoice-dialog-btn"
    />
  </ng-template>
</p-dialog>
